'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('reflect-metadata');
var vueClassComponent = require('vue-class-component');

var Logger = /** @class */ (function () {
    function Logger() {
    }
    Logger.info = function (message) {
        console.info(message);
    };
    Logger.warn = function (message) {
        console.warn(message);
    };
    Logger.error = function (message) {
        console.error(message);
    };
    Logger.debug = function (message) {
        console.debug(message);
    };
    Logger.log = function (message) {
        console.log(message);
    };
    return Logger;
}());

var TypeTable = /** @class */ (function () {
    function TypeTable() {
        this.types = new Map();
    }
    TypeTable.getInstance = function () {
        if (this._instance == null) {
            this._instance = new TypeTable();
        }
        return this._instance;
    };
    TypeTable.find = function (name) {
        return TypeTable.getInstance().find(name);
    };
    TypeTable.has = function (name) {
        return TypeTable.getInstance().has(name);
    };
    TypeTable.add = function (info) {
        TypeTable.getInstance().add(info);
    };
    TypeTable.prototype.find = function (name) {
        if (this.has(name)) {
            return this.types.get(name);
        }
        return null;
    };
    TypeTable.prototype.has = function (name) {
        return this.types.has(name);
    };
    TypeTable.prototype.add = function (info) {
        this.types.set(info.getName(), info);
    };
    return TypeTable;
}());

var TypeInfo = /** @class */ (function () {
    function TypeInfo(name, namespace, _constructor) {
        this.name = name;
        this.namespace = namespace;
        this._constructor = _constructor;
    }
    TypeInfo.prototype.getName = function () {
        return this.name;
    };
    TypeInfo.prototype.getSimpleName = function () {
        return this.name;
    };
    TypeInfo.prototype.getFullName = function () {
        return this.name + "," + this.namespace;
    };
    TypeInfo.prototype.newInstance = function () {
        return new this._constructor();
    };
    return TypeInfo;
}());

function __Type(type) {
    return function (target) {
        var name = type.name;
        var namespace = type.namespace;
        if (!TypeTable.has(name)) {
            var info = new TypeInfo(name, namespace, target);
            target['$type'] = info;
            TypeTable.getInstance().add(info);
        }
    };
}

var SimpleObjectCreator = /** @class */ (function () {
    function SimpleObjectCreator() {
    }
    SimpleObjectCreator.prototype.create = function (json) {
        var jObj = JSON.parse(json);
        var type = jObj['$type'];
        if (type) {
            var name_1 = type.split(',')[0];
            if (this.exist(name_1)) {
                var typeinfo = TypeTable.find(name_1);
                var instance = typeinfo.newInstance();
                Object.assign(instance, jObj);
                return instance;
            }
        }
        return null;
    };
    SimpleObjectCreator.prototype.exist = function (typename) {
        return TypeTable.has(typename);
    };
    return SimpleObjectCreator;
}());

var CompositeObjectCreator = /** @class */ (function () {
    function CompositeObjectCreator() {
    }
    CompositeObjectCreator.prototype.create = function (json) {
        var jObj = JSON.parse(json);
        if (Array.isArray(jObj)) {
            var arrObj = [];
            this.createObject(jObj, arrObj);
            return arrObj;
        }
        else {
            var type = jObj['$type'];
            if (type) {
                var name_1 = type.split(',')[0];
                var creator = new SimpleObjectCreator();
                if (creator.exist(name_1)) {
                    var tobject = creator.create(json);
                    this.createObject(jObj, tobject);
                    return tobject;
                }
            }
        }
        return jObj;
    };
    CompositeObjectCreator.prototype.createObject = function (source, target) {
        for (var key in source) {
            if (!!source[key] && typeof source[key] === 'object') {
                if (source[key].hasOwnProperty('$type')) {
                    var type = source[key]['$type'];
                    var name_2 = type.split(',')[0];
                    var creator = new SimpleObjectCreator();
                    if (creator.exist(name_2)) {
                        target[key] = creator.create(JSON.stringify(source[key]));
                        this.createObject(target[key], target[key]);
                    }
                }
                else if (Array.isArray(source[key])) {
                    this.createObject(source[key], target[key]);
                }
                else {
                    target[key] = source[key];
                }
            }
        }
    };
    return CompositeObjectCreator;
}());

var TObjectCreator = /** @class */ (function () {
    function TObjectCreator() {
    }
    TObjectCreator.prototype.create = function (json) {
        var jObj = JSON.parse(json);
        var type = jObj['$type'];
        if (type) {
            var name_1 = type.split(',')[0];
            if (this.exist(name_1)) {
                var typeinfo = TypeTable.find(name_1);
                var instance = typeinfo.newInstance();
                Object.assign(instance, jObj);
                return instance;
            }
        }
        return null;
    };
    TObjectCreator.prototype.exist = function (typename) {
        return TypeTable.has(typename);
    };
    return TObjectCreator;
}());

var MixObjectCreator = /** @class */ (function () {
    function MixObjectCreator() {
        this._itemsCreator = [];
    }
    MixObjectCreator.prototype.create = function (json) {
        var jObj = JSON.parse(json);
        if (Array.isArray(jObj)) {
            var arrObj = [];
            this.createObject(jObj, arrObj);
            return arrObj;
        }
        else {
            var type = jObj['$type'];
            if (type) {
                var name_1 = type.split(',')[0];
                for (var _i = 0, _a = this._itemsCreator; _i < _a.length; _i++) {
                    var creator = _a[_i];
                    if (creator.exist(name_1)) {
                        var tobject = creator.create(json);
                        this.createObject(jObj, tobject);
                        return tobject;
                    }
                }
            }
        }
        return jObj;
    };
    MixObjectCreator.prototype.add = function (objectCreator) {
        this._itemsCreator.push(objectCreator);
    };
    MixObjectCreator.prototype.createObject = function (source, target) {
        for (var key in source) {
            if (!!source[key] && typeof source[key] === 'object') {
                if (source[key].hasOwnProperty('$type')) {
                    var type = source[key]['$type'];
                    var name_2 = type.split(',')[0];
                    for (var _i = 0, _a = this._itemsCreator; _i < _a.length; _i++) {
                        var creator = _a[_i];
                        if (creator.exist(name_2)) {
                            target[key] = creator.create(JSON.stringify(source[key]));
                            if (creator instanceof TObjectCreator) {
                                this.createObject(target[key], target[key]);
                            }
                            break;
                        }
                    }
                }
                else if (Array.isArray(source[key])) {
                    this.createObject(source[key], target[key]);
                }
                else {
                    target[key] = source[key];
                }
            }
        }
    };
    return MixObjectCreator;
}());

var TObject = /** @class */ (function () {
    function TObject() {
        var typeinfo = this.getTypeInfo();
        if (typeinfo)
            this['$type'] = typeinfo.getFullName();
    }
    TObject.create = function (json, creator) {
        if (this.objectCreator == null) {
            if (creator) {
                this.objectCreator = creator;
            }
            else {
                this.objectCreator = new MixObjectCreator();
                this.objectCreator.add(new TObjectCreator());
            }
        }
        return this.objectCreator.create(json);
    };
    TObject.init = function (creator) {
        if (creator instanceof MixObjectCreator) {
            creator.add(new TObjectCreator());
        }
        this.objectCreator = creator;
    };
    TObject.prototype.getTypeInfo = function () {
        var meta = this['__proto__'].constructor;
        var typeinfo = meta['$type'];
        return typeinfo;
    };
    TObject.prototype.copy = function () {
        var type = this.getTypeInfo();
        var object = type.newInstance();
        return Object.assign(object, this);
    };
    TObject.prototype.equals = function (another) {
        return Object.is(this, another);
    };
    TObject.prototype.toString = function () {
        return JSON.stringify(this);
    };
    return TObject;
}());

var Container = /** @class */ (function () {
    /**
     * 容器类的构造函数
     */
    function Container() {
        // super();
        this.container = new Map();
    }
    /**
     * 注册
     * @param type - 注册变量的key
     * @param instance -  注册变量的具体实例
     */
    Container.prototype.register = function (type, instance) {
        this.container.set(type, instance);
    };
    /**
     * 通过注册变量的key获取容器中注册变量的实例
     * @param type - 注册变量的key
     */
    Container.prototype.resolve = function (type) {
        if (this.container.has(type)) {
            return this.container.get(type);
        }
    };
    Container.prototype.has = function (type) {
        return this.container.has(type);
    };
    /**
     * 通过变量key移除容器中注册变量的实例
     * @param type  - 注册变量的key
     */
    Container.prototype.remove = function (type) {
        if (this.container.has(type)) {
            this.container.delete(type);
        }
    };
    /**
     * 获取容器集合中容器类的大小
     * @returns {number} - 返回容器的数量
     */
    Container.prototype.getCount = function () {
        return this.container.size;
    };
    /**
     * 通过注册变量的key查找容器
     * @param type - 注册变量的key
     * @returns {any} 返回具体容器
     */
    Container.prototype.find = function (type) {
        return this.container.get(type);
    };
    /**
     * 获取容器
     * @returns {any}
     */
    Container.prototype.get = function () {
        return this.container;
    };
    /**
     * 容器合并
     * @param {Container} container
     * @returns {Container}
     */
    Container.prototype.concat = function (container) {
        var that = this;
        container.get().forEach(function (value, key) {
            if (!that.container.has(key)) {
                that.container.set(key, value);
            }
        });
        return this;
    };
    return Container;
}());

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var EventDispatcher = /** @class */ (function () {
    function EventDispatcher() {
        this._eventMap = {};
    }
    EventDispatcher.create = function () {
        if (this.instance == null) {
            this.instance = new EventDispatcher();
        }
        return this.instance;
    };
    EventDispatcher.prototype.on = function (eventID, callback, thisObj) {
        var that = this;
        if (eventID.constructor === Array) {
            eventID.forEach(function (event) {
                that.addEventListener(event, callback, thisObj);
            });
        }
        else {
            this.addEventListener(eventID, callback, thisObj);
        }
        return this;
    };
    EventDispatcher.prototype.once = function (eventID, callback, thisObj) {
        this.addEventListener(eventID, callback, thisObj, true);
        return this;
    };
    EventDispatcher.prototype.has = function (eventID, callback, thisObj) {
        return this.hasEventListener(eventID, callback, thisObj);
    };
    EventDispatcher.prototype.off = function (eventID, callback, thisObj) {
        this.removeEventListener(eventID, callback, thisObj);
        return this;
    };
    EventDispatcher.prototype.offAll = function (eventID) {
        if (eventID) {
            delete this._eventMap[eventID];
        }
        return this;
    };
    EventDispatcher.prototype.offTarget = function (target) {
        this.removeEventListenerByTarget(target);
        return this;
    };
    EventDispatcher.prototype.emit = function (eventID, data) {
        this.dispatchEvent(eventID, data);
        return this;
    };
    EventDispatcher.prototype.addEventListener = function (eventID, callback, thisObj, once) {
        if (once === void 0) { once = false; }
        if (this.hasEventListener(eventID, callback, thisObj))
            return;
        var list = this._eventMap[eventID];
        if (!list) {
            list = [];
            this._eventMap[eventID] = list;
        }
        list.push({ eventID: eventID, callback: callback, thisObj: thisObj, once: once });
    };
    EventDispatcher.prototype.hasEventListener = function (eventID, callback, thisObj) {
        var list = this._eventMap[eventID];
        if (!list)
            return false;
        var len = list.length;
        for (var idx = 0; idx < len; idx++) {
            var eventData = list[idx];
            if (eventData && eventData.thisObj === thisObj)
                return true;
        }
        return false;
    };
    EventDispatcher.prototype.removeEventListener = function (eventID, callback, thisObj) {
        var list = this._eventMap[eventID];
        var len = list.length;
        for (var idx = 0; idx < len; idx++) {
            var eventData = list[idx];
            if (eventData && eventData.callback === callback && eventData.thisObj === thisObj) {
                list.splice(idx, 1);
                break;
            }
        }
    };
    EventDispatcher.prototype.removeEventListenerByTarget = function (thisObj) {
        for (var key in this._eventMap) {
            var list = this._eventMap[key];
            this._eventMap[key] = list.filter(function (value) {
                return !(value.thisObj === thisObj);
            }, this);
        }
    };
    EventDispatcher.prototype.dispatchEvent = function (eventID, data) {
        var list = this._eventMap[eventID];
        if (!list)
            return;
        var cloneList = list.slice(0);
        var len = cloneList.length;
        for (var idx = 0; idx < len; idx++) {
            var eventData = cloneList[idx];
            eventData.once && this.removeEventListener(eventID, eventData.callback, eventData.thisObj);
            eventData.callback.call(eventData.thisObj, data);
        }
    };
    return EventDispatcher;
}());

var Event = /** @class */ (function () {
    function Event() {
        this.eventDispatcher = EventDispatcher.create();
    }
    Event.prototype.on = function (event, callback, thisObj) {
        var that = thisObj || this;
        this.eventDispatcher.on(event, callback, that);
    };
    Event.prototype.emit = function (event, data) {
        this.eventDispatcher.emit(event, data);
    };
    Event.prototype.off = function (event, callback, thisObj) {
        var that = thisObj || this;
        if (callback) {
            this.eventDispatcher.off(event, callback, that);
        }
        else {
            this.eventDispatcher.offAll(event);
        }
    };
    Event.prototype.once = function (event, callback, thisObj) {
        var that = thisObj || this;
        this.eventDispatcher.once(event, callback, that);
    };
    return Event;
}());

var ModuleBase = /** @class */ (function (_super) {
    __extends(ModuleBase, _super);
    function ModuleBase() {
        return _super.call(this) || this;
    }
    ModuleBase.prototype.initialize = function (container) {
    };
    ModuleBase.prototype.destory = function () {
    };
    ModuleBase.prototype.configure = function () {
        this.configureView();
        this.configureRouter();
        this.configureService();
    };
    ModuleBase.prototype.init = function (mcontainer, gcontainer) {
        this.container = mcontainer;
        this.gcontainer = gcontainer;
    };
    ModuleBase.prototype.configureView = function () {
    };
    ModuleBase.prototype.configureRouter = function () {
    };
    ModuleBase.prototype.configureService = function () {
    };
    ModuleBase.prototype.addService = function (type, service) {
        this.container.register(type, service);
    };
    ModuleBase.prototype.register = function (type, instance) {
        this.container.register(type, instance);
    };
    ModuleBase.prototype.resolve = function (type) {
        return this.container.resolve(type) || this.gcontainer.resolve(type);
    };
    ModuleBase.prototype.registerGlobal = function (type, instance) {
        this.gcontainer.register(type, instance);
    };
    return ModuleBase;
}(Event));

var Component = /** @class */ (function () {
    function Component() {
    }
    Component.addComponent = function (compName, container) {
        if (!this.components.has(compName)) {
            this.components.set(compName, container);
        }
    };
    Component.getContainer = function (comName) {
        return this.components.get(comName);
    };
    Component.has = function (comName) {
        return this.components.has(comName);
    };
    Component.components = new Map();
    return Component;
}());

var SimpleModule = /** @class */ (function (_super) {
    __extends(SimpleModule, _super);
    function SimpleModule() {
        var _this = _super.call(this) || this;
        _this.componentNames = [];
        _this.moduleContainer = new Container();
        _this.componentNames = [];
        return _this;
    }
    SimpleModule.prototype.initialize = function (container) {
        _super.prototype.init.call(this, this.moduleContainer, container);
        this.globalContainer = container;
        this.configure();
    };
    SimpleModule.prototype.destory = function () {
    };
    SimpleModule.prototype.configure = function () {
        _super.prototype.configure.call(this);
        this.setComponetContainer();
    };
    SimpleModule.prototype.setComponetContainer = function () {
        for (var i = 0; i < this.componentNames.length; i++) {
            var getContainer = Component.getContainer(this.componentNames[i]);
            if (getContainer) {
                getContainer.concat(this.moduleContainer).concat(this.globalContainer);
            }
        }
    };
    SimpleModule.prototype.setGlobalContainer = function (container) {
        this.globalContainer = container;
    };
    SimpleModule.prototype.addComponent = function (compName) {
        this.componentNames.push(compName);
    };
    return SimpleModule;
}(ModuleBase));

var ModuleLoader = /** @class */ (function () {
    function ModuleLoader() {
    }
    ModuleLoader.addModule = function (module) {
        this.modules.push(module);
    };
    ModuleLoader.start = function () {
        var _this = this;
        this.gcontainer.register('notify', new Event());
        this.modules.forEach(function (module) {
            module.initialize(_this.gcontainer);
        });
    };
    ModuleLoader.modules = new Array();
    ModuleLoader.gcontainer = new Container();
    return ModuleLoader;
}());

function Injectable() {
    return function (target, key) {
        vueClassComponent.createDecorator(function (componentOptions, key) {
            var data = {};
            var compName = componentOptions.name;
            var container = new Container();
            Component.addComponent(compName, container);
            data[key] = container;
            target[key] = container;
            (componentOptions.mixins || (componentOptions.mixins = [])).push({
                data: function () {
                    var _a;
                    return _a = {}, _a[key] = data[key], _a;
                }
            });
        })(target, key);
    };
}

var Theme = /** @class */ (function () {
    function Theme() {
    }
    Theme.change = function (cssUrl) {
        var head = document.getElementsByTagName('head')[0];
        var _loop_1 = function (i) {
            var currentChild = head.children[i];
            if (currentChild.rel && currentChild.rel === 'stylesheet' && currentChild.href.includes('theme')) {
                setTimeout(function () {
                    currentChild.parentNode.removeChild(currentChild);
                }, 500);
            }
        };
        // 卸载原有主题样式，设定定时器是为了防止抖动
        for (var i = head.children.length - 1; i > -1; i--) {
            _loop_1(i);
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = cssUrl;
        head.appendChild(link);
    };
    return Theme;
}());

exports.CompositeObjectCreator = CompositeObjectCreator;
exports.Container = Container;
exports.Injectable = Injectable;
exports.Logger = Logger;
exports.MixObjectCreator = MixObjectCreator;
exports.ModuleBase = ModuleBase;
exports.ModuleLoader = ModuleLoader;
exports.SimpleModule = SimpleModule;
exports.TObject = TObject;
exports.TObjectCreator = TObjectCreator;
exports.Theme = Theme;
exports.__Type = __Type;
